import { createSharedComposable } from '@vueuse/core';

// eslint-disable-next-line regex/invalid
import { RequestPasswordResetModal, SessionExpiredModal } from '#components';

type UseModalsReturn = {
    openRequestPasswordResetModal: (props?: { email: string }) => void;
    closeRequestPasswordResetModal: () => void;

    openSessionExpiredModal: () => void;
    closeSessionExpiredModal: () => void;
};

export const _useModals = (): UseModalsReturn => {
    const overlay = useOverlay();
    const { isLoggedIn } = useAuthUtils();

    // MODALS
    const requestPasswordResetModal = overlay.create(RequestPasswordResetModal);
    const sessionExpiredModal = overlay.create(SessionExpiredModal);

    return {
        openRequestPasswordResetModal: props => !isLoggedIn.value && requestPasswordResetModal.open(props),
        closeRequestPasswordResetModal: () => requestPasswordResetModal.close(),

        openSessionExpiredModal: () => sessionExpiredModal.open(),
        closeSessionExpiredModal: () => sessionExpiredModal.close(),
    };
};

export const useModals = createSharedComposable(_useModals);
